import { Loader } from "@partners/ui";
import { createFileRoute } from "@tanstack/react-router";

import { AuthenticatedAppLayout } from "@/components/AppLayout";
import { AUTH_REDIRECT_ERROR_TEXT, AuthError } from "@/components/Error";
import { logger } from "@/utils/logger";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated && !context.auth.error) {
      void context.auth.loginWithRedirect({
        appState: { returnTo: location.href },
      });
      throw new Error(AUTH_REDIRECT_ERROR_TEXT);
    }

    if (context.auth.error) {
      logger.error(context.auth.error);
      void context.auth.logout();
    }
  },
  errorComponent: AuthError,
  component: AuthenticatedAppLayout,
  pendingComponent: () => <Loader />,
});
